module.exports = __webpack_public_path__ + "static/media/plan.e3b09264.png";